import {Component, Injector, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";

@Component({
    selector: 'admin-setting',
    templateUrl: './admin-setting.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AdminSettingComponent extends BasePageComponentDirective<any> implements OnInit {

    constructor(
        injector: Injector,
    ) {
        super(injector);
    }

    override ngOnInit(): void {
        super.ngOnInit();

    }

    public override query(): void {
        throw new Error("Method not implemented.");
    }


}
